import { z } from 'zod';
// Schemas for ai-service request/response and task-specific outputs
export const GenerateRequestSchema = z.object({
    schema_id: z.string(),
    schema_hash: z.string(),
    system_prompt: z.string(),
    user_prompt: z.string(),
    context_snippets: z.array(z.string()).optional(),
    seed: z.number().int().optional(),
    model: z.string().optional(),
    temperature: z.number().optional(),
    top_p: z.number().optional(),
    max_tokens: z.number().int().optional(),
});
export const GenerateResponseSchema = z.object({
    schema_id: z.string(),
    seed: z.number().int().optional(),
    output: z.record(z.any()),
});
export const RegionNameOutputSchema = z.object({
    name: z.string().min(1).max(128)
});
export const MotivationsCheckSchema = z.object({
    valid: z.boolean().describe('True if the text is considered acceptable per the requirements in your instructions.'),
    failure_reason: z.object({
        audit: z.string().describe('Fully detailed reasoning for failing validity check for audit logging.'),
        user: z.string().describe('Brief 1-2 sentence explanation for failing validity check to display to the user.')
    }).nullable()
});
export const ArchetypeSelectionSchema = z.object({
    archetype: z.enum(['combat', 'magic', 'stealth'])
});
export const MotivationDigestOutputSchema = z.object({
    statement: z.string().min(1).describe('A 1-2 sentence third-person restatement of the player\'s answer, with the player as the subject.')
});
const MAX_EXTRACT_CANDIDATES = 3;
export const ReificationCandidateSchema = z.object({
    kind: z.enum(['npc', 'place', 'item']),
    // Nullable on purpose: the scan pass only IDENTIFIES entities, and the text may
    // name a specific item/place without giving it a name ("a letter addressed to
    // Elara"). The extract-*-details pass coins the real name later. Each type decides
    // what to do with a null name: NPCs without a proper name are dropped
    // (isExtractableNpcName), items get a name coined, and unnamed places are skipped. 
    // Do NOT tighten this to a required string — that crashes the whole scan batch 
    // when the model honestly reports an unnamed entity.
    name: z.string().nullable(),
    descriptor: z.string().min(1).max(100),
});
export const ReificationScanOutputSchema = z.object({
    entities: z.array(ReificationCandidateSchema).max(MAX_EXTRACT_CANDIDATES)
});
// Output for the item description prompt (`item/describe`): a single flavor
// sentence generated from a name when none was authored (e.g. table-rolled
// item names in motivation accumulation).
export const ItemDescribeOutputSchema = z.object({
    description: z.string().min(1).max(200),
});
